export default "__VITE_ASSET__BdCoXmoJ__ 480w, __VITE_ASSET__zOdCWcV4__ 768w, __VITE_ASSET__B8mrq_Y8__ 1200w, __VITE_ASSET__Da_eFr6Q__ 1920w";